import React from 'react'

const Inner = ({ children }) => {
    return (
        <div className="w-full md:w-421">{children}</div>
    )
}

export default Inner